import CircleSpinner from '@components/CircleSpinner'

const LoadingFeedback = () => (
  <div className='flex flex-col items-center justify-center min-h-[100px] py-5 mt-3'>
    <CircleSpinner size='lg' />
    <p className='mt-4 text-gray-600 dark:text-gray-300'>Hang tight! AI is generating your feedback...</p>
  </div>
)

export default LoadingFeedback 
